import { call, put, takeEvery } from 'redux-saga/effects'
import * as subAdminActions from '../ducks/subAdminDucks'
import * as subAdminApi from '../../api/subAdminApi'

function* fetchList() {
  try {
    const res: any = yield call(subAdminApi.listSubAdmin)
    yield put(subAdminActions.getSubAdminListSuccess(res))
  } catch (error) {
    yield put(subAdminActions.getSubAdminListFail(error))
  }
}

function* doAssign(action: any) {
  try {
    const duAnIds = action.payload.duAnIds || action.payload.hethongIds || []
    yield call(subAdminApi.assignSubAdmin, action.payload.userId, duAnIds)
    yield put(subAdminActions.assignSubAdminSuccess())
    yield put(subAdminActions.getSubAdminList())
  } catch (error) {
    yield put(subAdminActions.assignSubAdminFail(error))
  }
}

function* doRemoveOne(action: any) {
  try {
    yield call(subAdminApi.removeSubAdminHeThong, action.payload.userId, action.payload.hethongId)
    yield put(subAdminActions.removeSubAdminHeThongSuccess())
    yield put(subAdminActions.getSubAdminList())
  } catch (error) {
    yield put(subAdminActions.removeSubAdminHeThongFail(error))
  }
}

function* doRemoveAll(action: any) {
  try {
    yield call(subAdminApi.removeSubAdmin, action.payload.userId)
    yield put(subAdminActions.removeSubAdminSuccess())
    yield put(subAdminActions.getSubAdminList())
  } catch (error) {
    yield put(subAdminActions.removeSubAdminFail(error))
  }
}

export default function* watchSubAdmin() {
  yield takeEvery(subAdminActions.getSubAdminList.toString(), fetchList)
  yield takeEvery(subAdminActions.assignSubAdmin.toString(), doAssign)
  yield takeEvery(subAdminActions.removeSubAdminHeThong.toString(), doRemoveOne)
  yield takeEvery(subAdminActions.removeSubAdmin.toString(), doRemoveAll)
}